import React from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'

import Layout from './components/Layout'
import {
  Login,
  Register,
  ForgotPassword,
  SamlLogin,
} from './components/Authentication'

import Amplify from 'aws-amplify'
import aws_exports from './aws-exports'
import { UserProvider } from './hooks/useUser'

import '@fortawesome/fontawesome-free/css/fontawesome.css'
import '@fortawesome/fontawesome-free/css/solid.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'admin-console-common/build/css/font-face.css'
import 'admin-console-common/build/scss/admin-base.scss'
import './App.scss'
import ROUTES from './routes'

const auth = {
  region: aws_exports.aws_appsync_region,
  userPoolId: aws_exports.aws_user_pools_id,
  userPoolWebClientId: aws_exports.aws_user_pools_web_client_id,
  identityPoolId: aws_exports.aws_cognito_identity_pool_id,
  oauth: {
    domain: aws_exports.aws_user_pools_domain_url,
    scope: ['email', 'openid', 'aws.cognito.signin.user.admin'],
    redirectSignIn: aws_exports.aws_user_pools_web_client_redirect_url,
    redirectSignOut: aws_exports.aws_user_pools_web_client_redirect_url,
    // redirectSignIn: "http://localhost:3000/",
    // redirectSignOut: "http://localhost:3000/",
    responseType: 'code',
  },
}

Amplify.configure({ ...aws_exports, ...{ Auth: auth } })

const App = () => {
  return (
    <UserProvider>
      <HashRouter>
        <Routes>
          <Route exact path="/oldlogin" name="Login Page" element={<Login />} />
          <Route
            exact
            path="/login"
            name="Login Page"
            element={<SamlLogin />}
          />
          <Route
            exact
            path="/register"
            name="Register Page"
            element={<Register />}
          />
          <Route
            exact
            path="/forgotpassword"
            name="Forgot Password Page"
            element={<ForgotPassword />}
          />
          <Route path="/" name="Layout" element={<Layout />}>
            {ROUTES.map((route, idx) => {
              return (
                route.element && (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    element={<route.element />}
                  />
                )
              )
            })}
          </Route>
        </Routes>
      </HashRouter>
    </UserProvider>
  )
}

export default App
